import React, { memo, useCallback } from 'react';
import { ModelJson } from 'types/model';
import { Divider, Typography } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { analytics } from 'utils';
import { AkitLogo, McLogo, MirLogo, OkLogo, TgLogo, VisaLogo, VkLogo } from './icons';
import {
  AkitLogoPaymentsWrap,
  AkitLogoWrapper,
  desktopText,
  FooterBottomPaymentsWrap,
  FooterBottomWrap,
  FooterPaymentsWrap,
  FooterPolicyAkitWrap,
  FooterSocialLinksWrap,
  FooterSocialPaymentsWrap,
  policyLink,
  PolicyLinks,
  SocialLink,
  socialPolicyDiv,
} from './styles';

export const DATA_QA_SOCIAL_LINK = 'footer-social-link';

export type FooterSocialLinksProps = {
  footer: ModelJson['footer'];
};

export const FooterSocialLinks = memo<FooterSocialLinksProps>(({ footer }) => {
  const { t } = useTranslation();
  const socialLinksMap = [
    {
      linkName: 'vk',
      title: t('footer.socials.vk'),
      Logo: VkLogo,
    },
    {
      linkName: 'telegram',
      title: t('footer.socials.tg'),
      Logo: TgLogo,
    },
    {
      linkName: 'ok',
      title: t('footer.socials.ok'),
      Logo: OkLogo,
    },
  ];
  const socialMediaLinks = footer.socialMediaLinks as Record<string, string>;
  const socialLinkClick = useCallback(
    (title: string) => () => {
      analytics.sendEvent('GA:clickButton', {
        elementType: 'button',
        elementBlock: 'footer',
        elementName: 'socials',
        elementText: title,
      });
    },
    []
  );
  return (
    <FooterBottomWrap>
      <FooterSocialPaymentsWrap>
        <FooterSocialLinksWrap>
          {socialLinksMap.map(({ linkName, title, Logo }) => (
            <SocialLink
              key={title}
              href={socialMediaLinks[linkName]}
              target="_blank"
              rel="noopener noreferrer"
              onClick={socialLinkClick(title)}
              data-qa={DATA_QA_SOCIAL_LINK}>
              <Logo />
              <Typography className={desktopText} variant="s" size="body_long" color="text-invert">
                {title}
              </Typography>
            </SocialLink>
          ))}
        </FooterSocialLinksWrap>
        <FooterPaymentsWrap>
          <MirLogo />
          <McLogo />
          <VisaLogo />
        </FooterPaymentsWrap>
      </FooterSocialPaymentsWrap>
      <Divider className={socialPolicyDiv} />
      <FooterPolicyAkitWrap>
        <PolicyLinks>
          <a href="/politika-obrabotki-personalnykh-dannykh/">
            <Typography variant="s" size="body_long" color="text-invert" className={policyLink}>
              {t('footer.underline.personal')}
            </Typography>
          </a>
          <a href="/pravila/">
            <Typography variant="s" size="body_long" color="text-invert" className={policyLink}>
              {t('footer.underline.sell-rules')}
            </Typography>
          </a>
          <a href="/pravila-primeneniya-rekomendatelnyh-tehnologiy/">
            <Typography variant="s" size="body_long" color="text-invert" className={policyLink}>
              {t('footer.underline.technology-rules')}
            </Typography>
          </a>
        </PolicyLinks>
        <AkitLogoPaymentsWrap>
          <FooterBottomPaymentsWrap>
            <MirLogo />
            <McLogo />
            <VisaLogo />
          </FooterBottomPaymentsWrap>
          <AkitLogoWrapper>
            <AkitLogo />
          </AkitLogoWrapper>
        </AkitLogoPaymentsWrap>
      </FooterPolicyAkitWrap>
    </FooterBottomWrap>
  );
});
